import { OutgoingCancelRequest } from "../messages/methods/cancel";
import { OutgoingRequestDelegate } from "../messages/outgoing-request";
import { OutgoingRequestMessage } from "../messages/outgoing-request-message";
import { NonInviteClientTransaction } from "../transactions/non-invite-client-transaction";
import { UserAgentCore } from "../user-agent-core/user-agent-core";
import { UserAgentClient } from "./user-agent-client";

/**
 * CANCEL UAC.
 * @public
 */
export class CancelUserAgentClient extends UserAgentClient implements OutgoingCancelRequest {
  constructor(core: UserAgentCore, message: OutgoingRequestMessage, delegate?: OutgoingRequestDelegate) {
    super(NonInviteClientTransaction, core, message, delegate);
  }
}
